import { useCallback, useMemo } from 'react';
import { useSessionAreaName, useSessionCollectionName } from '@/platform-services/session';
const PERSISTED_STORAGE = 'gbi:rule_table_v2_persisted_storage';
export const useTablePersistedData = () => {
    const activeCollection = useSessionCollectionName();
    const activeArea = useSessionAreaName();
    const storageName = useMemo(() => (`${PERSISTED_STORAGE}-${activeCollection}-${activeArea}`), [activeCollection, activeArea]);
    const getPersistedData = useCallback(() => JSON.parse(localStorage.getItem(storageName) || '{}'), [storageName]);
    const persistedData = useMemo(() => getPersistedData(), [getPersistedData]);
    const setPersistedData = useCallback((newData) => {
        localStorage.setItem(storageName, JSON.stringify(Object.assign(Object.assign({}, getPersistedData()), newData)));
    }, [storageName, getPersistedData]);
    return {
        persistedData,
        setPersistedData,
    };
};
